import { render, staticRenderFns } from "./Vaalit.vue?vue&type=template&id=38128bc6&scoped=true"
var script = {}
import style0 from "./Vaalit.vue?vue&type=style&index=0&id=38128bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38128bc6",
  null
  
)

export default component.exports